import React from 'react';
import Wrapper from './style';

const Index = (props) => {
  const { children, isTable, style, className } = props;
  return (
    <Wrapper isTable={isTable} style={style} className={className || ''}>
      {children}
    </Wrapper>
  );
};

export default Index;
